import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class EstablishmentService {
  constructor(private http: HttpClient, private cookie: CookieService) {}
  updateEstablishment(body: any, id: number): Observable<any> {
    return this.http.put(
      `${environment.api.BASE_URL}/etablissements/${id}`,
      body
    );
  }

  getEstablishmentById(id: any): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/etablissements/${id}`);
  }

  getEstablishmentByIdV2(id: any): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/v2/etablissements/${id}`);
  }

  getEstablishmentStats(id: any): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/etablissements/stat/${id}`
    );
  }
  // http://dev.collary.fr:8080/api/etablissements/stat/33

  getSitesByEstablishmentId(id: any): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/etablissements/${id}/sites`
    );
  }
  getRegions(): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/missions/regions`);
  }
  getAddress(search: string, country?: string): Observable<any> {
    // Photon (photon.komoot.io) is built for autocomplete (prefix matching), unlike
    // Nominatim which needs near-complete terms (e.g. "GENEV" returned nothing, "GENEVE" did).
    // Normalized to the Nominatim-like shape so callers keep working unchanged.
    const url = `https://photon.komoot.io/api/?q=${encodeURIComponent(search)}&lang=fr&limit=10&countrycode=FR`;
    return this.http.get<any>(url).pipe(
      map((res: any) => (res?.features || [])
        .filter((f: any) => this.isPreciseAddress(f))
        .map((f: any) => this.mapPhotonFeature(f)))
    );
  }

  // Keep any result that has a single real postcode — houses, streets AND communes all pass.
  // Drops only noise: regions/states/countries (no postcode) and multi-postcode district
  // blobs (e.g. Paris "75000;75001;…").
  private isPreciseAddress(f: any): boolean {
    const pc = f?.properties?.postcode;
    return !!pc && !pc.includes(';');
  }

  private mapPhotonFeature(f: any): any {
    const p = f?.properties || {};
    const coords = f?.geometry?.coordinates || [];
    const city = p.city || p.town || p.village || '';
    const postcode = (p.postcode || '').split(';')[0].trim();
    return {
      lat: coords[1],
      lon: coords[0],
      display_name: [p.housenumber, p.street || p.name, postcode, city, p.country]
        .filter(Boolean)
        .join(' '),
      address: {
        house_number: p.housenumber || '',
        road: p.street || p.name || '',
        postcode,
        city,
        town: p.town || '',
        village: p.village || '',
        county: p.county || '',
        state: p.state || '',
        country: p.country || '',
        country_code: (p.countrycode || '').toLowerCase(),
      },
    };
  }
  getRegionByPostalCode(postalCode: string): Observable<any> {
    return this.http.get(
      `${environment.api.COMMUNES_URL}?codePostal=${postalCode}`
    );
  }
  getRegionByCode(code: string): Observable<any> {
    return this.http.get(`${environment.api.REGIONS_URL}/${code}`);
  }
  generateContract(
    candidateId: number,
    missionId: number,
    establishmentId: number
  ): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/generate/save-contract-in-docsign?idCandidat=${candidateId}&idMission=${missionId}&idEtablissement=${establishmentId}`,
      { responseType: 'text' }
    );
  }

  generateContractPreview(
    candidateId: number,
    missionId: number,
    establishmentId: number
  ): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/generate/sign-url?candidatId=${candidateId}&missionId=${missionId}&preview=${establishmentId}`,
      { responseType: 'text' }
    );
  }

  getSiteByEstablishmentId(id: number, isVisible?: boolean): Observable<any> {
    return this.http.get(
      `${environment.api.BASE_URL}/etablissements/${id}/sites?isVisible=${isVisible}`
    );
  }

  get establishment(): any {
    try {
      return JSON.parse(this.cookie.get('establishment'));
    } catch {
      return null;
    }
  }
}
//back.dev.collary.fr/api/generate/save-contract-in-docsign?idCandidat=22&idMission=34&idEtablissement=33
